namespace GeniuzPOS.Points {
    export class PrPointCampaignColumns {
        static columnsKey = 'Points.PrPointCampaign';
    }
}
